import type { SearchConditions } from '~/types/search-conditions';
import { camelToSnake } from './utils';

export function generateDynamicPath(searchConditions: SearchConditions) {
  const searchParams = new URLSearchParams();
  Object.entries(searchConditions).forEach(([key, value]) => {
    const snakeKey = camelToSnake(key);
    // 配列の場合はカンマ区切りで追加
    if (Array.isArray(value) && value.length > 0) {
      searchParams.set(`jobs_search[${snakeKey}]`, value.join(','));
    } else if (!Array.isArray(value) && value !== null && value !== '') {
      searchParams.set(`jobs_search[${snakeKey}]`, value);
    }
  });
  return `/jobs/search?${searchParams.toString()}`;
}
